import { PlanSeq } from '@mobi/api-types'
import dayjs from '@mobi/utils/date/extendedDayjs'
import { getPlanSequenceFromSelection } from '@mobi/betslip/helpers/getPlanSequence'
import { isFobDetails } from '@mobi/betslip/helpers/typeGuards'
import { getTicketLayoutType } from '@core/Areas/AccountActivity/Components/Ticket/helpers'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import type { ShareBetData } from '@core/Areas/ShareBet/types'
import type { FollowMeShareTicket } from '@core/Areas/FollowMe/types'

const allowedPlanSeqShares = [
  PlanSeq.Unknown,
  PlanSeq.Win,
  PlanSeq.Place,
  PlanSeq.WinAndPlace,
  PlanSeq.Exacta,
  PlanSeq.ExactaWithRovingBanker,
  PlanSeq.Quinella,
  PlanSeq.Trifecta,
  PlanSeq.TrifectaWithRovingBanker,
  PlanSeq.First4,
  PlanSeq.First4WithRovingBanker,
  PlanSeq.Double,
  PlanSeq.Quaddie,
  PlanSeq.FOBRacing,
]

export const shouldAllowShareInBetLoop = (data: ShareBetData) => {
  if (data.contextType === 'ticket') {
    const leg = data.share.ticket.legs[0]
    const isComboMulti = data.share.ticket.formula !== null

    return !(
      leg.eventType === 'Greys Box Challenge' ||
      leg.eventType === 'Jockey Challenge' ||
      !allowedPlanSeqShares.includes(data.share.ticket.planSeq) ||
      isComboMulti ||
      hasEventsStarted(data.share.ticket)
    )
  }

  if (data.contextType === 'betslip' || data.contextType === 'quickbet') {
    const details = data.share.items[0].selectionDetails
    const isFoo = isFobDetails(details)
    const isComboMulti = Object.values(data.share.multiReceipt?.formulaResponse ?? {}).some(
      v => v !== null
    )

    return !(
      (isFoo && details.competitionName === 'Greys Box Challenge') ||
      (isFoo && details.competitionName === 'Jockey Challenge') ||
      !allowedPlanSeqShares.includes(getPlanSequenceFromSelection(data.share.items[0].selection)) ||
      isComboMulti
    )
  }

  return false
}

// =============
// Local Helpers
// =============

function hasEventsStarted(ticket: Ticket | FollowMeShareTicket): boolean {
  const currentTime = dayjs()
  const ticketLayoutType = getTicketLayoutType(ticket)

  if (ticketLayoutType === 'multi') {
    return ticket.legs.some(leg => currentTime.isAfter(leg.advertisedStartTime))
  }

  if (ticketLayoutType === 'single-multiple' && ticket.allUpStartTimes) {
    return ticket.allUpStartTimes.some(time => currentTime.isAfter(time))
  }

  return currentTime.isAfter(ticket.legs[0].advertisedStartTime)
}
